import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import { useSelector } from "react-redux";

import apiService from "@/services/api.service";

import { integerValidate, toast } from "@/services/Utils";
import Fetching from "@/components/Fetching/Fetching";

const CreateReturnSearch = ({ data, setData, items, setItems, openSearch, setOpenSearch }) => {
	const { addToast } = useToasts();
	const { filter } = useSelector((state) => state.auth);
	const { type_currency } = filter;

	const [code, setCode] = useState("");
	const [loading, setLoading] = useState(false);

	const handleClose = () => {
		setCode("");
		setOpenSearch(false);
	};

	const handleConfirm = () => {
		if (!code) {
			toast(addToast, "Ingrese un código para buscar el producto.", "error");
			return;
		}

		setLoading(true);
		apiService
			.get("/client/orders_return/detail_product", {
				code,
				type_currency,
			})
			.then((response) => {
				const { response_items } = response;
				let newAllItems = [...items];
				let newItems = [...data.details];

				response_items.forEach((item) => {
					if (!newItems.find((inv) => Number(inv.value) === Number(item.value))) {
						newItems.push(item);
					}

					newAllItems.push(item);
				});

				setData({ ...data, details: newItems });
				setItems(newAllItems);
				handleClose();

				if (response_items.length === 0) {
					toast(
						addToast,
						"No se encontró ningún producto con el código ingresado. También posible que el producto ya tenga aplicaciones asociadas.",
						"error",
					);
				}

				setLoading(false);
			});
	};

	return (
		<Modal show={openSearch} onHide={() => handleClose()} backdrop="static" keyboard={false}>
			<Modal.Header closeButton>
				<Modal.Title style={{ fontSize: "1em" }}>Buscar Código</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{loading ? (
					<Fetching topMargin={"0em"} />
				) : (
					<Form.Control
						style={{ marginTop: "10px" }}
						value={code}
						onChange={(e) => setCode(e.target.value)}
						onKeyDown={integerValidate}
						type="text"
					/>
				)}
			</Modal.Body>
			<Modal.Footer>
				<Button style={{ fontSize: "0.8em" }} variant="success" onClick={() => handleConfirm()} disabled={!code || loading ? true : false}>
					{loading ? "BUSCANDO PRODUCTO..." : "CONFIRMAR"}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default CreateReturnSearch;
